import React from 'react';
import MailActions from 'actions/inbox/MailActions';
import ToastActions from '@store/toast/ToastActions';
import IconButton from 'material-ui/IconButton';
import classNames from 'classnames';
import {errorCommunicating} from 'utils/const';
import './PinToggle.styl';
import MailSource from 'sources/inbox/MailSource';
import {PinIcon} from '@components/icon/PinIcon';

export default class PinToggle extends React.PureComponent {
  onPin = async e => {
    e.stopPropagation();
    const {item} = this.props;
    try {
      const desiredState = !item.pinned;

      // save the group container pin-ness
      const savePromise = MailActions.saveMail(item.set('pinned', desiredState), item);

      // if grouped, we must update the grouped items with the exact same
      // desired state from the parent item (toggling everything could be undesirable)
      // also be careful not to re-save the one we just tried to save above
      if (item.isGrouped) {
        MailSource.bulkSetPinned({
          ids: item.groupedItems.filter(i => i.id !== item.id).map(i => i.id),
          folderId: item.folderId,
          pinned: desiredState,
        });
      }

      await savePromise;

      ToastActions.addToast({
        message: (!item.pinned ? 'Pinned' : 'Unpinned') + ' item.',
        time: 1500,
      });
    } catch (e) {
      ToastActions.addToast({type: 'error', message: errorCommunicating});
    }
  };

  render() {
    const {item} = this.props;
    return (
      <IconButton onClick={this.onPin} title="Pin item" className="inbox-pin-toggle">
        <PinIcon className={classNames({active: item.pinned})} />
      </IconButton>
    );
  }
}
